function getBrowserName() {
  let userAgent = navigator ? navigator.userAgent.toLowerCase() : 'other';
  if (userAgent.indexOf('chrome') > -1) return 'chrome';
  else if (userAgent.indexOf('safari') > -1) return 'safari';
  else if (userAgent.indexOf('msie') > -1) return 'ie';
  else if (userAgent.indexOf('firefox') > -1) return 'firefox';
  return userAgent;
}

function getActiveXObject(name: string) {
  try {
    return new ActiveXObject(name);
  } catch (e) {}
}

function getNavigatorPlugin(name: string) {
  for (let key in navigator.plugins) {
    let plugin = navigator.plugins[key];
    if (plugin.name == name) return plugin;
  }
}

function getPDFPlugin() {
  if (getBrowserName() == 'ie') {
    // load the activeX control
    // AcroPDF.PDF is used by version 7 and later
    // PDF.PdfCtrl is used by version 6 and earlier
    return getActiveXObject('AcroPDF.PDF') || getActiveXObject('PDF.PdfCtrl');
  } else {
    return getNavigatorPlugin('Adobe Acrobat') || getNavigatorPlugin('Chrome PDF Viewer') || getNavigatorPlugin('WebKit built-in PDF');
  }
}

export default function isAcrobatInstalled() {
  return !!getPDFPlugin();
}
